import { ModeleDeBase } from "./ModeleDeBase";

export interface IPeriodeCDS {
  si_tariflocation: number;
  createdon?: string;
  si_periodeactive?: boolean;
  si_sequenceperiodelocation?: string;
  si_tariflocation_base?: number;
  si_nomcourtperiode?: string;
  si_periodedelocationid: string;
  si_ordretri: number;
  si_datedebutlocation: string;
  si_tauxtps: number;
  si_tauxtvq: number;
  si_datefinlocation: string;
  si_periodetermine?: boolean;
  si_nomdelaperiodedelocation: string;
}

export class Periode extends ModeleDeBase {
  ordretri: number;
  nomPeriode: string;
  dateDebut: string;
  dateFin: string;
  tauxTPS: number;
  tauxTVQ: number;
  tarifLocation: number;

  constructor(entity: IPeriodeCDS) {
    super(entity.si_periodedelocationid);

    this.ordretri = entity.si_ordretri;
    this.nomPeriode = entity.si_nomdelaperiodedelocation;
    this.dateDebut = entity.si_datedebutlocation;
    this.dateFin = entity.si_datefinlocation;
    this.tauxTPS = entity.si_tauxtps;
    this.tauxTVQ = entity.si_tauxtvq;
    this.tarifLocation = entity.si_tariflocation;
  }

  serialiser(): IPeriodeCDS {
    return {
      si_periodedelocationid: this.id,
      si_ordretri: this.ordretri,
      si_nomdelaperiodedelocation: this.nomPeriode,
      si_datedebutlocation: this.dateDebut,
      si_datefinlocation: this.dateFin,
      si_tauxtps: this.tauxTPS,
      si_tauxtvq: this.tauxTVQ,
      si_tariflocation: this.tarifLocation,
    };
  }
}
